var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12919"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12918"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16041",
    d: "M20.186 8.406H6.906a1.552 1.552 0 00-1.515 1.187v.008l-2.287 7.721a.392.392 0 00.012.256 1.555 1.555 0 001.449.982h13.28a1.557 1.557 0 001.5-1.133c0-.008.006-.017.009-.026l2.321-6.951a.385.385 0 00.016-.068 1.517 1.517 0 00.061-.415 1.564 1.564 0 00-1.566-1.561z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16042",
    d: "M3.335 12.607a.357.357 0 00.056 0 .39.39 0 00.374-.28l.87-2.939v-.013a2.34 2.34 0 012.267-1.754h12.041a.391.391 0 00.368-.521 1.564 1.564 0 00-1.468-1.041h-7.26L9.135 4.614a.39.39 0 00-.276-.114h-4.3A1.564 1.564 0 003 6.062v6.158a.391.391 0 00.335.387z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 14782",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgFilesIcon;